import { Controller } from "@hotwired/stimulus"

// Controller for managing tabbed interfaces
export default class extends Controller {
  static targets = ["tab", "content"]

  connect() {
    // Show the first tab by default
    this.showTab(this.tabTargets[0])
  }

  switch(event) {
    event.preventDefault()
    const clickedTab = event.currentTarget
    this.showTab(clickedTab)
  }

  showTab(tabElement) {
    const language = tabElement.dataset.language

    // Update tab styles
    this.tabTargets.forEach(tab => {
      if (tab === tabElement) {
        // Active tab
        tab.classList.remove("border-transparent", "text-gray-500", "hover:text-gray-700", "hover:border-gray-300")
        tab.classList.add("border-primary", "text-primary")
      } else {
        // Inactive tabs
        tab.classList.remove("border-primary", "text-primary")
        tab.classList.add("border-transparent", "text-gray-500", "hover:text-gray-700", "hover:border-gray-300")
      }
    })

    // Show/hide content panels
    this.contentTargets.forEach(content => {
      if (content.dataset.language === language) {
        content.classList.remove("hidden")
      } else {
        content.classList.add("hidden")
      }
    })
  }
}
